import * as PIXI from 'pixi.js'
import prefix from 'prefix'
import * as math from 'utils/math.js'
import Detector from 'utils/Detector'
import TweenMax from 'gsap'
import Emitter from 'core/Emitter'
import MaskFilter from 'filters/Mask/MaskFilter'
import OpacifyFilter from 'filters/Opacify/OpacifyFilter'
import SimplexNoise from 'simplex-noise'

export default class Flower extends PIXI.Container {
  constructor (opts) {
    super()

    this.indexFlower = opts.index
    this.isSingle = opts.isSingle
    this.renderer = opts.renderer
    this.resources = opts.resources
    this.data = opts.data
    this.scene = opts.scene
    this.originalSize = this.data.size
    this.prefix = `${this.data.id}_${this.data.title}`
    this.filtersArray = this.data.filters
    this.moveBase = this.data.move_base
    this.prefixTransform = prefix('transform')
    this.anchorPoint = this.data.anchor || [0.5, 1]
    this.size = Detector.getScreenSize()
    this.simplex = new SimplexNoise()

    this.wind = {
      force: 0,
      speed: 0
    }

    this.interactive = true
    this.isOvered = false
    this.mousePoint = {
      x: -1000,
      y: -1000
    }

    this.isUnmasked = false
    this.isUnmasking = false

    this.bindAll()
    this.addListeners()

    this.flowerContainer = new PIXI.Container()
    this.addChild(this.flowerContainer)

    this.data.children.forEach((el) => this.createChild(el))

    this.scene.addChild(this)

    if (!this.isSingle) this.createTitle()
    this.createHtml()

    this.renderTextureMask = PIXI.RenderTexture.create(this.width, this.height)
    this.createMask()
    this.createOpacityFilter()
  }

  bindAll () {
    ['update', 'resize', 'createChild']
    .forEach((fn) => (this[fn] = this[fn].bind(this)))
  }

  /**
   * Handler mouse
   */
  addListeners () {
    if (Detector.isMobile()) {
      if (!this.isSingle) {
        if (Detector.is('iOS')) {
          this.click = () => {
            Emitter.emit('OPEN_SINGLE', this.data.title)
          }
        } else {
          this.tap = () => {
            Emitter.emit('OPEN_SINGLE', this.data.title)
          }
        }
      }

      // this.touchstart = () => {
      //   this.isOvered = true
      //   // Emitter.emit('SHOW_PARTICLES', this)
      // }
      //
      // this.touchend = () => {
      //   this.isOvered = false
      //   // Emitter.emit('HIDE_PARTICLES', this)
      // }
    } else {
      this.mouseover = () => {
        this.isOvered = true
        // Emitter.emit('SHOW_PARTICLES', this)
        Emitter.emit('SOUND::PLAY_FLOWER_OVER')

        // this.wind.force = 5

        this.tlWind = new TimelineMax({
          onComplete: () => {

          }
        })

        this.tlWind.fromTo(this.wind, 2, {
          force: this.wind.force,
          speed: this.wind.speed,
          ease: Quint.easeOut
        }, {
          force: () => {
            return math.random(-5, 6)
          },
          speed: () => {
            return math.random(0, 5)
          },
          ease: Expo.easeOut
        }, 'start')
        // .to(this.wind, 1, {
        //   force: 0,
        //   speed: 0,
        //   ease: Elastic.easeOut
        // }, 'start+=1')

        // this.tlWind.reverse()

        if (this.titleBar) {
          TweenMax.to(this.titleBar.scale, 0.8, {
            x: 1,
            ease: Quint.easeOut
          })
          TweenMax.to(this.titleBar, 0.8, {
            alpha: 1,
            ease: Quint.easeOut
          })
        }

        !this.isSingle && document.body.classList.add('is-hovered')
      }

      this.mouseout = () => {
        this.isOvered = false
        Emitter.emit('HIDE_PARTICLES', this)
        Emitter.emit('SOUND::STOP_FLOWER_OVER')

        this.tlWind.stop()
        this.tlWind = new TimelineMax()

        let d = math.random(1, 3, true)

        this.tlWind.to(this.wind, d, {
          force: 0,
          speed: 0,
          ease: Sine.easeOut
        })

        // this.tlWind.stop()
        // // this.tlWind = new TimelineMax({
        // //   onComplete: () => {
        // //     console.log(this.wind)
        // //   }
        // // })
        // TweenMax.to(this.wind, 1, {
        //   force: 0,
        //   speed: 0,
        //   ease: Quint.easeOut
        // })

        if (this.titleBar) {
          TweenMax.to(this.titleBar.scale, 0.8, {
            x: 0,
            ease: Quint.easeOut
          })
          TweenMax.to(this.titleBar, 0.8, {
            alpha: 0,
            ease: Quint.easeOut
          })
        }

        !this.isSingle && document.body.classList.remove('is-hovered')
      }

      if (!this.isSingle) {
        this.click = () => {
          Emitter.emit('OPEN_SINGLE', this.data.title)
          Emitter.emit('SOUND::PLAY_FLOWER_CLICK')
        }
      }
    }
  }

  removeListeners () {
    if (Detector.isMobile()) {
      this.tap = null
      this.touchstart = null
      this.touchend = null
    } else {
      this.mousemove = null
      this.mouseover = null
      this.mouseout = null
      this.click = null
    }
  }

  isSprite (el) {
    return !el.children
  }

  isContainer (el) {
    return el.children
  }

  isInViewport (scrollY) {
    let rect = {}
    rect.top = this.position.y - this.size.h
    rect.bottom = rect.top + this.height + this.size.h
    // let result = rect.top <= this.size.h && rect.bottom > 0

    /**
        let limitIn = (this.bounds.filtersContainer.top)
        let limitOut = limitIn + this.offsetHeight + (this.size.h / 2 - this.offsetHeight / 2)
        let limitOutVp = limitIn + this.offsetHeight - this.size.h - this.bounds.filtersContainer.paddingTop

        let vp = this.scrollY.current > limitIn &&
        this.scrollY.current < limitOutVp
    **/
    let offsetY = 0
    if (scrollY.offset) offsetY = scrollY.offset
    let result = ((scrollY.dest) - offsetY) > rect.top && ((scrollY.dest) - offsetY) < rect.bottom

    if (result) {
      // this.alpha = 1
      if (!this.interactive) {
        if (!this.renderer.isCanvas) {
          this.cacheAsBitmap = false
        }
        this.interactive = true
        // this.visible = true
      }
    } else {
      // this.alpha = 0.5
      if (this.interactive) {
        if (!this.renderer.isCanvas) {
          this.cacheAsBitmap = true
        }
        this.interactive = false
        // this.visible = false
      }
    }

    return result
  }

  createOpacityFilter () {
    if (this.renderer.isCanvas) {
      this.fallbackOpacity = new PIXI.Graphics()
      this.fallbackOpacity.beginFill(0xf3f1dd)
      this.fallbackOpacity.drawRect(0, 0, this.width, this.height)
      this.fallbackOpacity.endFill()

      this.fallbackOpacity.alpha = 0

      this.flowerContainer.addChild(this.fallbackOpacity)
    } else {
      this.opacityFilter = new OpacifyFilter()
      this.opacityFilter.uniforms.alpha = 1
    }
  }

  opacifyFlower () {
    if (this.renderer.isCanvas) {
      TweenMax.to(this.fallbackOpacity, 2, {
        alpha: 0.85,
        ease: Expo.easeOut,
        onComplete: () => {
          this.isOpacified = true
          // this.flowerContainer.filters = null
        }
      })
    } else {
      this.flowerContainer.filters = [this.opacityFilter]
      TweenMax.to(this.opacityFilter.uniforms, 2, {
        alpha: 0.1,
        ease: Expo.easeOut,
        onComplete: () => {
          this.isOpacified = true
          // this.flowerContainer.filters = null
        }
      })
    }
  }

  desopacifyFlower () {
    if (this.renderer.isCanvas) {
      TweenMax.to(this.fallbackOpacity, 2, {
        alpha: 0,
        ease: Expo.easeOut,
        onComplete: () => {
          this.isOpacified = false
        }
      })
    } else {
      TweenMax.to(this.opacityFilter.uniforms, 2, {
        alpha: 1,
        ease: Expo.easeOut,
        onComplete: () => {
          this.isOpacified = false
          this.flowerContainer.filters = null
        }
      })
    }
  }

  createMask () {
    this.thresholdSprite = new PIXI.Sprite(PIXI.Texture.fromFrame(`threshold`))
    // this.thresholdSprite.width = this.width
    // this.thresholdSprite.height = this.height

    let maskIntroContainer = new PIXI.Container()
    maskIntroContainer.addChild(this.thresholdSprite)

    this.renderer.render(maskIntroContainer, this.renderTextureMask)

    this.maskIntroSprite = new PIXI.Sprite(this.renderTextureMask)
    // this.maskIntroSprite.alpha = 0.5
    // this.maskIntroSprite.width = this.width
    // this.maskIntroSprite.height = this.height

    this.maskIntroFilter = new MaskFilter(this.maskIntroSprite)
    this.filters = [this.maskIntroFilter]

    this.addChild(this.maskIntroSprite)

    this.setAlphaMask(0)

    this.filterMask = new PIXI.Graphics()
    this.filterMask.beginFill(0x000000, 0.5)
    this.filterMask.drawRect(0, 0, this.width, this.height)
    this.filterMask.endFill()
    //
    // this.filterMask.alpha = 0.2
    //
    // this.flowerContainer.addChild(this.filterMask)
    // this.flowerContainer.mask = this.filterMask
  }

  setAlphaMask (value) {
    this.maskIntroFilter.uniforms.alpha = value
  }

  showMask () {
    this.isUnmasking = true
    TweenMax.to(this.maskIntroFilter.uniforms, 4, {
      alpha: 1,
      delay: (this.indexFlower % 5) * 0.2,
      ease: Expo.easeOut,
      onComplete: () => {
        this.isUnmasked = true
        this.isUnmasking = false
        this.filters = null
        // var index = this.filters.indexOf(this.maskIntroFilter)
        // this.filters.splice(index, 1)
      }
    })
  }

  hideMask (cb) {
    this.filters = [this.maskIntroFilter]
    this.isUnmasking = true

    if (this.hideMaskTl) {
      this.hideMaskTl.kill()
      this.hideMaskTl.eventCallback('onComplete', null)
    }

    this.hideMaskTl = TweenMax.to(this.maskIntroFilter.uniforms, 4, {
      alpha: 0,
      ease: Expo.easeOut,
      onComplete: () => {
        this.isUnmasked = false
        this.isUnmasking = false

        if (cb) {
          cb()
        }
      }
    })
  }
  removeMask () {}

  createHtml () {
    if (!document.querySelector('.app .flowers')) {

    } else {
      this.divFlowers = document.querySelector('.app .flowers')
    }

    this.divContainer = document.createElement('div')
    this.divContainer.classList.add('flower-container')
    // if (this.data.background) {
    //   this.divContainer.style.backgroundColor = this.data.background
    // }
    this.divFlowers.appendChild(this.divContainer)

    this.div = document.createElement('div')
    this.div.classList.add('flower')
    this.divContainer.appendChild(this.div)

    this.divPivot = document.createElement('div')
    this.divPivot.classList.add('pivot')
    this.div.appendChild(this.divPivot)
  }

  createChild (el, parent) {
    if (this.isContainer(el)) {
      let container = new PIXI.Container()
      container.anchorPoint = el.anchor || [0.5, 1]

      container.data = el
      container.data.mathOscillation = Math.round(Math.random()) ? 'cos' : 'sin'
      container.data.velocity = el.velocity || math.random(5, 15) / 10000

      el.children.forEach((child, i) => this.createChild(child, container))

      if (parent) {
        parent.addChild(container)
      } else {
        this.flowerContainer.addChild(container)
      }
    } else {
      let sprite = new PIXI.Sprite(PIXI.Texture.fromFrame(`${this.prefix}_${el.name}.png`))

      sprite.data = el
      sprite.data.mathOscillation = Math.round(Math.random()) ? 'cos' : 'sin'
      sprite.data.velocity = el.velocity || math.random(5, 15) / 10000

      sprite.anchor.set(el.anchor[0] || 0, el.anchor[1] || 0)

      sprite.x = sprite.width * el.anchor[0]
      sprite.y = sprite.height * el.anchor[1]

      sprite.x += el.position[0]
      sprite.y += el.position[1]

      if (parent) {
        parent.addChild(sprite)
      } else {
        this.flowerContainer.addChild(sprite)
      }
    }
  }

  createTitle () {
    let title = (this.data.title_long) ? this.data.title_long : this.data.title.charAt(0).toUpperCase() + this.data.title.slice(1)

    this.titleText = new PIXI.Text(title, {
      fontFamily: 'ChronicleTextG1-Italic',
      fontSize: (Detector.isMobile()) ? 25 : 20,
      fill: 0x000000,
      align: 'center'
    })

    this.titleText.anchor.set(0.5, 1)

    this.addChild(this.titleText)

    this.titleBar = new PIXI.Graphics()
    this.titleBar.beginFill(0xff3600)
    this.titleBar.drawRect(0, 2, this.titleText.width, 4)
    this.titleBar.endFill()

    this.titleBar.pivot.x = -this.titleText.width / 2
    this.titleBar.scale.x = 0
    this.titleBar.alpha = 0
    this.titleBar.x = -this.titleText.width

    this.titleText.addChild(this.titleBar)
  }

  positionPivot (child) {
    if (child instanceof PIXI.Sprite || child instanceof PIXI.Graphics) return

    let bounds = child.getLocalBounds()
    let xOffset = bounds.x
    let x = xOffset + (child.width * (child.anchorPoint[0]))

    let yOffset = bounds.y
    let y = yOffset + (child.height * (child.anchorPoint[1]))

    child.pivot.set(x, y)
    child.position.set(x, y)

    if (child.children) {
      child.children.forEach((el, i) => this.positionPivot(el))
    }

    // if (!child.hasPivotPointDrawed) {
    //   child.hasPivotPointDrawed = true
    //   let gr = new PIXI.Graphics()
    //   gr.x = x
    //   gr.y = y
    //   gr.beginFill(0x165af2)
    //   gr.drawCircle(0, 0, 6)
    //   gr.endFill()
    //   child.parent.addChild(gr)
    // }
  }

  resize (size, index, grid) {
    this.size = size

    if (this.isSingle) {
      let newW = this.size.w
      let newH = this.size.h

      let textureRatio = this.originalSize[0] / this.originalSize[1]
      let boxRatio = newW / newH

      let ratioW
      if (boxRatio < 1) {
        if (textureRatio < boxRatio) {
          ratioW = (newH) / this.originalSize[1]
        } else {
          ratioW = (newW) / this.originalSize[0]
        }
      } else {
        ratioW = (newH) / this.originalSize[1]
      }

      this.flowerContainer.scale.set(ratioW)

      let offsetWidth = (newW - this.flowerContainer.width) / 2
      let offsetHeight = (newH - this.flowerContainer.height) / 2

      this.positionPivot(this.flowerContainer.children[0])

      this.flowerContainer.pivot.set(this.originalSize[0] * this.anchorPoint[0], this.originalSize[1] * this.anchorPoint[1])
      this.flowerContainer.position.set((this.flowerContainer.width * this.anchorPoint[0]), (this.flowerContainer.height * this.anchorPoint[1]))

      this.position.set(offsetWidth, offsetHeight)
    } else {
      this.flowerIndex = index
      this.grid = grid

      let bigElement = false
      let newW = Math.min(this.size.w, this.grid.maxWidth) / grid.column()
      let h = Math.min(this.size.h, this.grid.maxHeight())
      let hH = h / 2

      let newH = 0
      let xPadding = 0

      if (size.w > this.grid.maxWidth) {
        xPadding = (size.w - this.grid.maxWidth) / 2
      }

      let xPos = xPadding
      let yPos = this.grid.startTop
      let itemsByRow = grid.itemsByRow()
      let col = grid.currentCol
      let marginMultiplier
      let offsetTypo = 0
      let bpMobile = false

      switch (this.size.BP) {
        case 'mobile':
        case 'xs-tablet':
          marginMultiplier = 0.9
          offsetTypo = 0
          bpMobile = true
          break

        default:
          marginMultiplier = 0.8
          break
      }

      if (index % (itemsByRow * 2) === 0 || index % (itemsByRow * 2) === itemsByRow) {
        switch (this.size.BP) {
          case 'mobile':
          case 'xs-tablet':
            marginMultiplier = 0.9
            break
          case 'tablet':
            marginMultiplier = 1
            break
          default:
            marginMultiplier = 1.2
            break
        }

        newH = h
        xPos += (index % (itemsByRow * 2) === 0) ? 0 : newW * (grid.column() - 1)
        yPos += h * (grid.row - 1)

        bigElement = true
      } else {
        newH = hH
        xPos += (index % (itemsByRow * 2) < itemsByRow) ? newW * col : newW * ((grid.column() - 1) - col)
        yPos += h * (grid.row - 1)
        yPos += (index % 2 === 0) ? hH : 0

        bigElement = false
      }

      let textureRatio = this.originalSize[0] / this.originalSize[1]
      let boxRatio = newW / newH

      let ratioW
      if (boxRatio < 1) {
        if (textureRatio < boxRatio) {
          ratioW = (newH * marginMultiplier) / this.originalSize[1]
        } else {
          ratioW = (newW * marginMultiplier) / this.originalSize[0]
        }
      } else {
        ratioW = (newH * marginMultiplier) / this.originalSize[1]
      }

      this.flowerContainer.scale.set(ratioW)

      let offsetWidth = (newW - this.flowerContainer.width) / 2
      let offsetHeight = (newH - this.flowerContainer.height) / 2

      this.positionPivot(this.flowerContainer.children[0])

      this.flowerContainer.pivot.set(this.originalSize[0] * this.anchorPoint[0], this.originalSize[1] * this.anchorPoint[1])
      this.flowerContainer.position.set((this.flowerContainer.width * this.anchorPoint[0]), (this.flowerContainer.height * this.anchorPoint[1]))

      this.position.set(offsetWidth + xPos, offsetHeight + yPos)

      this.titleText.position.x = this.flowerContainer.width / 2
      if (bpMobile) {
        this.titleText.position.y = this.flowerContainer.height + offsetHeight + offsetTypo
      } else {
        this.titleText.position.y = (bigElement) ? this.flowerContainer.height + (offsetHeight / 2) : this.flowerContainer.height + offsetHeight
      }

      if (this.maskIntroSprite) {
        this.maskIntroSprite.width = this.flowerContainer.width
        this.maskIntroSprite.height = this.flowerContainer.height

        this.filterMask.width = this.width * 1.2
        this.filterMask.height = this.height * 1.2
      }

      this.divContainer.style.width = `${newW}px`
      this.divContainer.style.height = `${newH}px`
      this.divContainer.style.left = `${(xPos)}px`
      this.divContainer.style.top = `${(yPos)}px`

      this.div.style.width = `${this.flowerContainer.width}px`
      this.div.style.height = `${this.flowerContainer.height - 1}px`
      this.div.style.left = `${offsetWidth}px`
      this.div.style.top = `${offsetHeight}px`

      this.divPivot.style.left = `${(this.flowerContainer.width * this.anchorPoint[0]) - 5}px`
      this.divPivot.style.top = `${((this.flowerContainer.height * this.anchorPoint[1]) - 10 - 2)}px`
    }
  }

  update ({
    time,
    wind,
    scrollY
  }) {
    // let destY = ((this.originalPosition.y) + (scrollY.current * -0.3))
    // this.position.y = destY
    // if (this.flowerIndex === 0 || this.flowerIndex === 2 || this.flowerIndex === 7) {

    // }

    if (this.isInViewport(scrollY)) {
      if (!this.isUnmasked && !this.isUnmasking) {
        this.showMask()
      }

      let force = wind.force.value + this.wind.force
      let speed = wind.speed.value
      // console.log(speed)
      // let maxRotation = this.children[0].data.maxRotation || 0
      let noForce = this.flowerContainer.children[0].data.noForce
      // let maxRotation = 5 * Math.PI / 180
      this.flowerContainer.rotation = (noForce) ? 0 : ((force * 0.3) * Math.PI / 180)

      this.flowerContainer.children[0].children.forEach((container) => {
        if (container.children.length > 0) {
          container.children.forEach((sprite) => {
            let data = sprite.data
            let maxRotation = data.maxRotation || 0
            let mathOscillation = data.mathOscillation || 'cos'
            let velocity = data.velocity || '0.001'
            let vx = (Date.now() * velocity)
            //
            // if (this.wind.speed > 0) {
            //   vx = this.wind.speed * speed
            // }

            let noForce = data.noForce
            let noise = this.simplex.noise2D(Date.now() * 0.0001, 1)
            let noisyWind = (noise) * speed

            sprite.rotation = ((force * ((noForce) ? 0.0 : 0.2)) * Math.PI / 180) + Math[mathOscillation]((speed * noisyWind) + (vx) + (this.wind.speed * 1)) * (Math.PI / 180 * (maxRotation))
          })

          let data = container.data
          let maxRotation = (data.maxRotation !== undefined) ? data.maxRotation : 2
          let mathOscillation = data.mathOscillation || 'cos'
          let velocity = data.velocity || '0.001'

          if (maxRotation) {
            container.rotation = ((force * 0.6) * Math.PI / 180) + Math[mathOscillation](Date.now() * (velocity * speed)) * Math.PI / 180 * (maxRotation)
          }
        } else {
          let data = container.data
          let maxRotation = (data.maxRotation !== undefined) ? data.maxRotation : 2
          let mathOscillation = data.mathOscillation || 'cos'
          let velocity = data.velocity || '0.001'

          if (maxRotation) {
            container.rotation = ((force * 0.6) * Math.PI / 180) + Math[mathOscillation](Date.now() * (velocity * speed)) * Math.PI / 180 * (maxRotation)
          }
        }

        /**
        var startRange = 0.98 // your chosen start value
        var endRange = 1.02 // your chose end value
        var oscilationRange = (endRange - startRange) / 2
        var oscilationOffset = oscilationRange + startRange

        this.flower1__flower1Sprite.scale.set(oscilationOffset + Math.cos(Date.now() * (0.001 * this.wind.speed)) * oscilationRange)
        this.flower1__flower2Sprite.scale.set(oscilationOffset + Math.sin(Date.now() * (0.001 * this.wind.speed)) * oscilationRange)
        **/
      })
    }
  }

  destroy () {
    this.divFlowers.removeChild(this.divContainer)

    document.body.classList.remove('is-hovered')
    this.scene.removeChild(this)
    super.destroy({
      children: true
    })

    if (this.hideMaskTl) {
      this.hideMaskTl.kill()
      this.hideMaskTl.eventCallback('onComplete', null)
    }

    this.removeListeners()
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Flower.js
 **/